<ng-select id="{{labelId}}"
           bindLabel="name"
           [multiple]="false"
           [addTag]="false"
           [placeholder]="'Select a company'"
           [disabled]="disabled"
           [items]="companiesSuggestion"
           (change)="updateCompany($event)"
           [typeahead]="companySearchControl">
</ng-select>
